import { useState, useEffect } from "react";
import axios from "axios";
import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import { getUserToken } from "utils/functions/userToken";

/**
 * Hook to fetch meta options for an account (shared audience & multi-hotel flags).
 * Calls GET /api/account/meta-options/?hotel_id={hotelId}
 *
 * @param {string|number} hotelId - The hotel ID to check options for
 * @returns {{ isSharedAudienceEnabled: boolean, isMultiHotelEnabled: boolean, isLoading: boolean }}
 */
const useMetaOptions = (hotelId) => {
  const [isSharedAudienceEnabled, setIsSharedAudienceEnabled] = useState(false);
  const [isMultiHotelEnabled, setIsMultiHotelEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!hotelId) return;
    setIsLoading(true);
    const token = getUserToken();
    axios
      .get(`${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/account/meta-options/`, {
        params: { hotel_id: hotelId },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setIsSharedAudienceEnabled(res.data?.shared_audience_enabled ?? false);
        setIsMultiHotelEnabled(res.data?.multiple_hotels_campaign ?? false);
      })
      .catch(() => {
        setIsSharedAudienceEnabled(false);
        setIsMultiHotelEnabled(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [hotelId]);

  return { isSharedAudienceEnabled, isMultiHotelEnabled, isLoading };
};

export default useMetaOptions;
